import { GridSettingsWebComponent } from './component/GridSettingsWebComponent';
import { WEB_COMPONENT_GRID_SETTINGS } from '../../webcomponents.constants';

export { GridSettingsWebComponent };

window.customElements.define(WEB_COMPONENT_GRID_SETTINGS, GridSettingsWebComponent);
